import { __assign } from "tslib";
export var getStyleFromTextPreset = function (wixParam, additionals) {
    if (additionals === void 0) { additionals = {}; }
    return (__assign({ 
        // additional can be minHeight, textDecoration, color
        fontFamily: wixParam.fontFamily, fontSize: wixParam.size, lineHeight: wixParam.lineHeight, fontStyle: wixParam.style, fontWeight: wixParam.weight }, additionals));
};
//# sourceMappingURL=theme.js.map